import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';

function EmailDetail() {
	const context = useContext(AppSettings);
	useEffect(() => {
		context.handleSetAppContentClass('p-0');
		context.handleSetAppContentFullHeight(true);
		return () => {
			context.handleSetAppContentClass('');
			context.handleSetAppContentFullHeight(false);
		};
	}, [context]);
	return (
		<>
			<div className="mailbox">
				<div className="mailbox-toolbar">
					<div className="mailbox-toolbar-item">
						<span className="mailbox-toolbar-text">{'Mailboxes'}</span>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link active">
							{'Inbox'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Sent'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Drafts (1)'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/inbox" className="mailbox-toolbar-link">
							{'Junk'}
						</Link>
					</div>
					<div className="mailbox-toolbar-item">
						<Link to="/email/compose" className="mailbox-toolbar-link">
							{'New Message'}
							<i className="fa fa-pen fs-12px ms-1"></i>
						</Link>
					</div>
				</div>
				<div className="mailbox-body">
					<div className="mailbox-sidebar d-none d-xl-block">
						<div data-scrollbar="true" data-height="100%">
							<div className="mailbox-list">
								<div className="mailbox-list-item unread has-attachment active">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox1"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox1"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">
													<i className="fab fa-apple"></i>
												</span>
												<span className="mailbox-sender-name">{'Apple'}</span>
												<span className="mailbox-time">{'1 hour ago'}</span>
											</div>
											<div className="mailbox-title">{'Your payment is received'}</div>
											<div className="mailbox-desc">
												{
													'Praesent id pulvinar orci. Donec ac metus non ligula faucibus venenatis. Suspendisse tortor est, placerat eu dui sed...'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item unread has-attachment">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox2"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox2"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon">
													<img
														src="/color-admin/admin/react/assets/img/user/profile.jpg"
														alt="User profile"
														className="object-fit-cover"
													/>
												</span>
												<span className="mailbox-sender-name">{'Chance Graham'}</span>
												<span className="mailbox-time">{'5 hours ago'}</span>
											</div>
											<div className="mailbox-title">{'Trip to South America'}</div>
											<div className="mailbox-desc">
												{
													'Quisque luctus sapien sodales pulvinar porta. In pretium accumsan elit, vitae blandit arcu suscipit eu. Ut tortor libero, gravida ut nisl tincidunt, efficitur laoreet mauris.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item has-attachment">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox3"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox3"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-primary text-white">
													<i className="fab fa-paypal"></i>
												</span>
												<span className="mailbox-sender-name">{'Paypal Inc'}</span>
												<span className="mailbox-time">{'Aug 11'}</span>
											</div>
											<div className="mailbox-title">
												{'Important information about your order #019244'}
											</div>
											<div className="mailbox-desc">
												{
													'Waltz, bad nymph, for quick jigs vex! Fox nymphs grab quick-jived waltz. Brick quiz whangs jumpy veldt fox. Bright vixens jump; dozy fowl quack. Quick wafting zephyrs vex bold Jim. Quick zephyrs blow, vexing daft Jim.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox4"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox4"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">{'F'}</span>
												<span className="mailbox-sender-name">{'Fitbit'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">
												{'Stylish accessories for your Charge 2'}
											</div>
											<div className="mailbox-desc">
												{
													'How quickly daft jumping zebras vex. Two driven jocks help fax my big quiz. Quick, Baz, get my woven flax jodhpurs! "Now fax quiz Jack!" my brave ghost pled.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox5"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox5"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-dark text-light">
													<i className="fab fa-apple"></i>
												</span>
												<span className="mailbox-sender-name">{'Apple'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">{'Your invoice from Apple.'}</div>
											<div className="mailbox-desc">
												{
													'Flummoxed by job, kvetching W. zaps Iraq. Cozy sphinx waves quart jug of bad milk. A very bad quack might jinx zippy fowls.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox6"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox6"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-red-600 text-white">{'H'}</span>
												<span className="mailbox-sender-name">{'Hotels.com'}</span>
												<span className="mailbox-time">{'Aug 09'}</span>
											</div>
											<div className="mailbox-title">
												{'[Ends tonight!] 48 Hour Sale - Save up to 50% + save an extra 10%'}
											</div>
											<div className="mailbox-desc">
												{
													'Phasellus vulputate, ligula ac hendrerit euismod, nunc metus maximus tellus, aliquam finibus justo lorem a augue.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox7"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox7"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-green text-white">
													<i className="fab fa-google"></i>
												</span>
												<span className="mailbox-sender-name">{'Google Calendar'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">
												{'Daily schedule on Tuesday, May 9, 2026'}
											</div>
											<div className="mailbox-desc">
												{
													'Suspendisse potenti. Praesent ac ullamcorper sem. Mauris luctus accumsan felis'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox8"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox8"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-blue text-white">
													<i className="fab fa-facebook-f"></i>
												</span>
												<span className="mailbox-sender-name">{'Facebook Blueprint'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">{'April 2026 – Blueprint Highlights'}</div>
											<div className="mailbox-desc">
												{
													'Phasellus pretium viverra tortor, eu sagittis erat aliquam nec. Nunc et volutpat ligula. Duis viverra posuere enim, ac bibendum massa viverra id.'
												}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox9"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox9"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-orange text-white">{'C'}</span>
												<span className="mailbox-sender-name">{'Customer Care'}</span>
												<span className="mailbox-time">{'Aug 08'}</span>
											</div>
											<div className="mailbox-title">
												{'Re: [Case #1567940] - Re: [Important] Exabytes'}
											</div>
											<div className="mailbox-desc">
												{'Nam imperdiet molestie arcu, et gravida quam lacinia lobortis.'}
											</div>
										</Link>
									</div>
								</div>
								<div className="mailbox-list-item">
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input
												className="form-check-input"
												type="checkbox"
												value=""
												id="mailCheckbox10"
											/>
											<label className="form-check-label" htmlFor="mailCheckbox10"></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-icon bg-light text-dark">{'F'}</span>
												<span className="mailbox-sender-name">{'Flight Status'}</span>
												<span className="mailbox-time">{'Aug 07'}</span>
											</div>
											<div className="mailbox-title">
												{'[Case#2017022137015743] *FLIGHT RETIMED* **MH2713/15JUL17**'}
											</div>
											<div className="mailbox-desc">
												{
													'Etiam condimentum orci ut velit suscipit, ut accumsan elit aliquet. Nulla cursus mi at augue vestibulum suscipit. Aenean ut risus euismod, laoreet justo non, convallis quam.'
												}
											</div>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="mailbox-content">
						<div className="mailbox-detail">
							<div className="mailbox-detail-header py-3 px-4">
								<div className="d-flex gap-3 align-items-center">
									<a href="#/">
										<img
											src="/color-admin/admin/react/assets/img/user/profile.jpg"
											alt=""
											width="50"
											className="rounded-circle"
										/>
									</a>
									<div className="flex-fill">
										<div className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="fw-600">{'John Smith <johnsmith@seantheme.com>'}</div>
												<div className="fs-13px">
													<span className="me-1">{'to'}</span>
													<a href="#/" className="text-decoration-none fw-semibold">
														{'admin@seantheme.com'}
													</a>
													{','}
													<a href="#/" className="text-decoration-none fw-semibold">
														{'support@seantheme.com'}
													</a>
												</div>
											</div>
											<div className="fs-12px text-muted text-end">
												{'Nov 27, 2026'}
												<br />
												{'at 7.00pm'}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="mailbox-detail-content">
								<div data-scrollbar="true" data-height="100%" data-skip-mobile="true" className="p-4">
									<h5 className="mb-3">{'Your payment is received'}</h5>
									<div className="mailbox-detail-attachment">
										<div className="mailbox-attachment">
											<a href="#/">
												<div className="document-file">
													<Icon icon="solar:zip-file-bold-duotone" />
												</div>
												<div className="document-name">{'invoice.zip'}</div>
											</a>
										</div>
										<div className="mailbox-attachment">
											<a href="#/">
												<div className="document-file">
													<Icon icon="solar:videocamera-record-bold-duotone" />
												</div>
												<div className="document-name">{'video.mp4'}</div>
											</a>
										</div>
										<div className="mailbox-attachment">
											<a href="#/">
												<div className="document-file">
													<img
														src="/color-admin/admin/react/assets/img/ai/imagine-10.jpg"
														alt=""
														className="object-fit-cover"
													/>
												</div>
												<div className="document-name">{'image.jpg'}</div>
											</a>
										</div>
									</div>
									<div className="mb-4">
										<a href="#/" className="btn btn-rounded px-3 btn-sm btn-primary">
											{'Download'}
										</a>
									</div>
									<div className="mailbox-detail-body">
										{'Hi Dear Customer,'}
										<br />
										<br />
										{
											'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vel auctor nisi, vel auctor orci.'
										}
										<br />
										{
											'Aenean in pretium odio, ut lacinia tellus. Nam sed sem ac enim porttitor vestibulum vitae at erat.'
										}
										<br />
										<br />
										{
											'Curabitur auctor non orci a molestie. Nunc non justo quis orci viverra pretium id ut est.'
										}
										<br />
										{'Nullam vitae dolor id enim consequat fermentum. Ut vel nibh tellus.'}
										<br />
										{'Duis finibus ante et augue fringilla, vitae scelerisque tortor pretium.'}
										<br />
										{'Phasellus quis eros erat. Nam sed justo libero.'}
										<br />
										<br />
										{
											'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.'
										}
										<br />
										{'Sed tempus dapibus libero ac commodo.'}
										<br />
										<br />
										<br />
										{'Regards,'}
										<br />
										{'Twitter Inc,'}
										<br />
										{'795 Folsom Ave, Suite 600'}
										<br />
										{'San Francisco, CA 94107'}
										<br />
										{'P: (123) 456-7890'}
										<br />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default EmailDetail;
